<template>
    <div class="overview-area">
        <div class="container-fluid">
            <div class="row m-0">
                <div class="col-xl-6 col-lg-12 col-md-12 p-0">
                    <div class="overview-content">
                        <h2>Most Probably You Are Getting Best {{ appName }} Ever</h2>
                        <p>Experience seamless productivity and peace of mind with our app. Effortlessly manage your data, collaborate securely, and access your information anytime, anywhere. Join thousands of businesses who trust us to power their digital transformation.</p>
                        <ul class="features-list">
                            <li>
                                <div class="icon">
                                    <i class="ri-download-cloud-2-line"></i>
                                </div>
                                <h3>Free Download App</h3>
                                <p>Get started instantly with a free download. No hidden fees just sign up and unlock powerful features designed to help your business grow.</p>
                            </li>
                            <li>
                                <div class="icon">
                                    <i class="ri-award-line"></i>
                                </div>
                                <h3>Trusted and Reliable</h3>
                                <p>Our platform is trusted by industry leaders for its reliability, security, and 24/7 support. Focus on your business while we handle the rest.</p>
                            </li>
                         
                        </ul>
                        <div class="btn-box">
                            <router-link to="/contact" class="default-btn">Contact Us</router-link>
                       
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 p-0">
                    <div class="overview-image bg1">
                        <div class="image-container">
                    <img src="../../assets/images/Most-probably.png" alt="overview">

                    <img src="../../assets/images/Probably-animation.png"  alt="animation image" class="animation-image">
                     </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.image-container { 
    position: relative;
    height: 640px;
    width: 640px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.animation-image {
    right: 104px;
    position: absolute;
    left: 50%;
    bottom: 100px;
    max-width: 100%;
    height: auto;
    pointer-events: none;
    animation: movebounce 2s linear infinite;
}
@media screen and (max-width: 600px) {
    .overview-image {
    margin-bottom: 30px;
}
.overview-image::before {
    left: 81px;
    bottom: 16px;
    width: 217px;
    height: 216px;
}
.overview-image img {
    width: 200px;
    object-fit: contain;
}
}

@media screen and (max-width: 767px) {
.image-container {
    height: unset;
    width: unset;
}
img.animation-image {
    display: none;
}
.overview-image.bg1 {
    display: none;
}
}
</style>
<script>
export default {
    name: 'BestAppStaticSection',
    props: {
        appName: {
            type: String,
            default: 'App'
        }
    }
}
</script> 